<script setup lang="ts">
import { substitutePlainTextVariables } from '@pkg/utilities/strings';
import CollapsibleSection from '~/app/components/base/CollapsibleSection.vue';

const props = defineProps<{
  brandName: string;
  cities: string[];
  citiesListTitle?: string | null;
  noCitiesAvailableText?: string | null;
}>();

const collapsibleTitle = computed(() => {
  const raw = props.citiesListTitle?.trim();
  if (!raw) {
    return `${props.brandName}'s TGTG stores`;
  }
  return substitutePlainTextVariables(raw, { brand: props.brandName });
});

const noCitiesMessage = computed(() => props.noCitiesAvailableText?.trim() || 'No cities available');

const emit = defineEmits<{
  'city-click': [city: string];
}>();

const handleCityClick = (city: string) => {
  emit('city-click', city);
};

const isSectionOpen = ref(true);
const getCollapsibleState = (isOpen: boolean) => (isSectionOpen.value = isOpen);
</script>

<template>
  <section>
    <CollapsibleSection :title="collapsibleTitle" :default-open="true" :title-class="'s-brand-list__title__secondary'" @toggle-collapsible="getCollapsibleState" />
    <template v-if="isSectionOpen">
      <div v-if="cities?.length > 0" class="s-brand-list__list">
        <button v-for="city in cities" :key="city" type="button" class="s-brand-list__item" @click="handleCityClick(city)">
          {{ city }}
        </button>
      </div>
      <p v-else class="s-brand-list__empty">
        {{ noCitiesMessage }}
      </p>
    </template>
  </section>
</template>

<style>
@import '~/assets/css/mixins/_mixins.index.pcss';

.s-brand-list__title__secondary {
  @mixin h5-tenon;
  font-weight: bold;
  padding: theme('spacing.16') 0px;
  color: var(--theme-heading-color-app);
}
</style>

<style scoped>

.s-brand-list__list {
  display: grid;
  padding-top: theme('spacing.16');
  gap: theme('spacing.16');

  @screen tablet {
    grid-template-columns: repeat(2, 1fr);
  }
  @screen desk {
    grid-template-columns: repeat(4, 1fr);
  }
}

.s-brand-list__item {
  text-align: left;
  padding-left: theme('spacing.8') theme('spacing.16');
  cursor: pointer;
  &:hover {
    color: var(--theme-heading-color-app);
  }
}

.s-brand-list__empty {
  padding-top: theme('spacing.16');
  color: var(--theme-text-color-app);
}
</style>
